import { fetchPaidNewslettersAccount, updatePaidNewslettersAccount } from '@/services/ApiCategories/paidNewsletters';
import { put, call, takeEvery, fork } from 'redux-saga/effects';
import { ActionTypes, PaidNewslettersStripeAccountUpdateAction } from '@/store/paidNewslettersStripeAccount/types';
import { PaidNewslettersStripeAccountFetchError, PaidNewslettersStripeAccountFetchSuccess, PaidNewslettersStripeAccountUpdateError, PaidNewslettersStripeAccountUpdateSuccess } from '@/store/paidNewslettersStripeAccount/actions';
import { CreateAccountConnect } from '@dev/ee-api/ee-api-models';
import { AxiosResponse } from 'axios';
import { errorToast } from './commonGenerators/errorToast';

function* fetchPaidNewslettersStripeAccount(): any {
    try {
        const paidNewslettersStripeAccount = yield call(fetchPaidNewslettersAccount);

        yield put(PaidNewslettersStripeAccountFetchSuccess(paidNewslettersStripeAccount?.data));
    } catch (e) {
        yield put(PaidNewslettersStripeAccountFetchError());
    }
}

function* updatePaidNewslettersStripeAccount(action: PaidNewslettersStripeAccountUpdateAction): any {
    try {
        const paidNewslettersStripeAccountUpdateResponse: AxiosResponse<CreateAccountConnect> = yield call(updatePaidNewslettersAccount, action.payload);
        
        const redirectUrl = paidNewslettersStripeAccountUpdateResponse.data.RedirectUrl;
        if (redirectUrl) {
            window.location.href = redirectUrl;
            return;
        } 
        console.error('No RedirectUrl found in response');
        yield put(PaidNewslettersStripeAccountUpdateSuccess(action.meta))
    } catch (e) {
        yield put(PaidNewslettersStripeAccountUpdateError(action.meta));
        yield call(errorToast, e);
    }
}

function* fetchPaidNewslettersStripeAccountWatcher(): any {
    yield takeEvery(ActionTypes.FETCH_START, fetchPaidNewslettersStripeAccount);
}
function* updatePaidNewslettersStripeAccountWatcher(): any {
    yield takeEvery(ActionTypes.UPDATE_START, updatePaidNewslettersStripeAccount);
}

const paidNewslettersStripeAccountSagas = [
    fork(fetchPaidNewslettersStripeAccountWatcher),
    fork(updatePaidNewslettersStripeAccountWatcher)
];

export default paidNewslettersStripeAccountSagas;